// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/weather_forecast_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { WeatherForecastService } from "./weather_forecast_service_pb";

/**
 * GetAreaWeatherForecast returns the 8-metric forecast bundle for the area
 * and target-date range. organization_id is resolved by the BFF handler
 * from eauth.
 *
 * @generated from rpc bffuser.v1.WeatherForecastService.GetAreaWeatherForecast
 */
export const getAreaWeatherForecast = WeatherForecastService.method.getAreaWeatherForecast;

/**
 * BatchGetAreaWeatherForecasts returns one forecast per requested area, in request order
 * (area_code identifies each element), for the shared target-date range.
 * organization_id is resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.WeatherForecastService.BatchGetAreaWeatherForecasts
 */
export const batchGetAreaWeatherForecasts = WeatherForecastService.method.batchGetAreaWeatherForecasts;
